import React from 'react'
// import {Link} from 'react-router-dom'
import strory1 from '../../images/story/1.jpg'
import strory2 from '../../images/story/2.jpg'
// import strory3 from '../../images/story/3.jpg'
import strory4 from '../../images/story/4.jpg'
import strory5 from '../../images/story/5.jpg'
import strory6 from '../../images/story/6.jpg'
import strory7 from '../../images/story/7.jpg'
import './style.css'


const Story = () =>{
    return(
        <div id="story" className="story-area section-padding">
            <div className="container">
                <div className="col-l2">
                    <div className="section-title text-center">
                        <h2>Our Story</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="story clearfix">
                            <div className="story-top"></div>
                            <div className="content-wrapper">
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory7} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>Where our story began</h2>
                                        <span className="date">May, 2022</span>
                                        <p>It all began at Digiratina. We had known each other while working from home, but when we started coming into the office, it hit me that the girl I had known was this innocent and kind person. And just like that, I fell in love with her,</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory2} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>First trip together</h2>
                                        <span className="date">September, 2022</span>
                                        <p>Our first trip together took us to Ella, the most magical and romantic city in Sri Lanka for us. We were joined by our closest friends, and it turned out to be the best trip ever. A perfect start to many more adventures together!,</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory1} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>Our first 'I Love You'</h2>
                                        <span className="date">October, 2022</span>
                                        <p>Our first 'I love you' was said at Aliya Resort and Spa, after an unforgettable night with the DJ, dancing like nobody was watching with the Digiratina team. Then we had a long talk about life, and in that moment, I finally told him, ‘I love you.’.</p>
                                    </div>
                                </div>
                                {/* <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory3} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>First flower bouquet</h2>
                                        <span className="date">October, 2022</span>
                                        <p>A gift as beautiful and vibrant as her. She loves flowers, and their charm never fails to brighten her mood, no matter the day,</p>
                                    </div>
                                </div> */}
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory6} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>First bike ride</h2>
                                        <span className="date">November, 2022</span>
                                        <p>After much convincing, she finally trusted me enough to hop on the bike with me. It may have been a short ride, but with her holding on tight, it felt like the start of something special. We knew this was a moment we’d cherish forever and couldn’t wait to share it with all of you.</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory4} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>First birthday with him</h2>
                                        <span className="date">January, 2023</span>
                                        <p>My first birthday with him!!!—a celebration at Pearl Beach with our Digiratina buddies. I got the cutest birthday cake ever, the most beautiful flower bouquet, and shared the best moments with him and friends,</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="story-icon">
                                        <span className="flaticon-birds-in-love"></span>
                                    </div>
                                    <div className="story-content">
                                        <div className="image-wrap">
                                            <div className="single-image">
                                                <div>
                                                    <img src={strory5} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>First birthday with her</h2>
                                        <span className="date">March, 2023</span>
                                        <p>A day filled with surprises, a wonderful party planned with my family and friends, celebrated at Gihan’s restaurant—our go-to place when we’re sad and when we’re happy. I felt surrounded by love, making it a truly unforgettable day,</p>
                                    </div>
                                </div>
                            </div>
                            <div className="story-bottom"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Story;